import { Config } from "../utils/config";

export const Endpoints = {
  IDENTITY: {
    TOKEN: Config.API_URL + "/api/Identity/Token",
    SEND_OTP: Config.API_URL + "/api/Identity/Otp-Code",
    VERIFY_OTP: Config.API_URL + "/api/Identity/Verify-Otp-Code",
    VALIDATE_SSO_TOKEN: Config.SSO_URL + "/api/Identity/Validate-Token",
    SSO_LOGIN: Config.API_URL + "/api/Identity/SSO",
  },
  CONTENT:{
    DASHBOARD:Config.API_URL+'/api/Content/Dashboard',
    GET_CONTENT:Config.API_URL+'/api/Content'

  }
};
